import { render, staticRenderFns } from "./ComisionEmpresas.vue?vue&type=template&id=2d44beb4&scoped=true&"
import script from "./ComisionEmpresas.vue?vue&type=script&lang=js&"
export * from "./ComisionEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44beb4",
  null
  
)

export default component.exports